import '../Cash';

$('.share-button').on('click', function(event) {
    event.stopPropagation();
    $('.share-button__menu').toggleClass('is-hidden');
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.share-button__menu').length) {
        $('.share-button__menu').addClass('is-hidden');
    }
});

$('#create-account-cta').on('click', function(event) {
    $('.modal-backdrop').toggleClass('is-hidden');
    document.getElementById('login-form-title').textContent = 'Create an account to see seller information';
});

document.querySelector('.modal-backdrop').addEventListener('click', function(event) {
    if (event.target === event.currentTarget) {
        $('.modal-backdrop').toggleClass('is-hidden');
    }
});

$('.modal__corner-close-button').on('click', function(event) {
    event.stopPropagation();
    $('.modal-backdrop').toggleClass('is-hidden');
});

$('.copy-icon-container').on('click', function() {
    var vinNumber = document.getElementById('vinNumber').textContent;
    navigator.clipboard.writeText(vinNumber);

    this.style.animation = 'clickAnimation 0.5s';

    this.addEventListener('animationend', function() {
        this.style.animation = '';
    }, {once: true});
});

$('#copy-share-button').on('click', function() {
    var currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl)
        .then(() => {
            $(this).find('.share-button__menu-item__text').text('Link Copied!');
        });
});

$('#save-vin').on('click', function() {
    $('.modal-backdrop').toggleClass('is-hidden');
    document.getElementById('login-form-title').textContent = 'Create an account to save this vehicle';
});

$('#facebook-share-button').on('click', () => {
    let url = window.location.href;
    let facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(facebookUrl, '_blank');
});

$('#x-share-button').on('click', () => {
    let text = "Check out this car I found in Bumper: ";
    let url = window.location.href;
    let xUrl = `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
    window.open(xUrl, '_blank');
});

$('#email-share-button').on('click', () => {
    let url = window.location.href;
    let subject = "Check out this car from Bumper!";
    let body = "Check out this car I found in Bumper: " + url;
    let mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
});

document.querySelectorAll('.toggle-content').forEach((item) => {
    item.addEventListener('click', (event) => {
        const columns = event.currentTarget.nextElementSibling;
        columns.classList.toggle('is-hidden');

        const chevron = event.currentTarget.querySelector('.fa-solid');
        if (chevron.classList.contains('fa-chevron-down')) {
            chevron.classList.remove('fa-chevron-down');
            chevron.classList.add('fa-chevron-up');
        } else {
            chevron.classList.remove('fa-chevron-up');
            chevron.classList.add('fa-chevron-down');
        }
    });
});

document.querySelectorAll('.more-options').forEach((item) => {
    item.addEventListener('click', (event) => {
        const extraOptions = event.currentTarget.previousElementSibling;
        extraOptions.classList.toggle('is-hidden');

        const textElement = event.currentTarget.querySelector('p');
        if (textElement.textContent === 'See more options') {
            textElement.textContent = 'See less options';
        } else {
            textElement.textContent = 'See more options';
        }

        const downIcon = event.currentTarget.querySelector('.fa-chevron-down');
        const upIcon = event.currentTarget.querySelector('.fa-chevron-up');
        downIcon.classList.toggle('is-hidden');
        upIcon.classList.toggle('is-hidden');
    });
});

document.querySelectorAll('.features-toggle').forEach((item) => {
    item.addEventListener('click', (event) => {
        const featuresContent = event.currentTarget.nextElementSibling;
        featuresContent.classList.toggle('is-hidden');

        const chevron = event.currentTarget.querySelector('i');
        if (chevron.classList.contains('fa-chevron-down')) {
            chevron.classList.remove('fa-chevron-down');
            chevron.classList.add('fa-chevron-up');
        } else {
            chevron.classList.remove('fa-chevron-up');
            chevron.classList.add('fa-chevron-down');
        }
    });
});